import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import TaskForm from "./TaskForm.js";
// import TaskForm from "./TaskForm.js";



function NewTask() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("jwtToken");
  const { userInfo } = useAuth();
  const { role } = userInfo;

  const handleCreate = async (data) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/new`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`          },
        }
      );
      navigate("/tasks");
    } catch (err) {
      console.error("Fout bij aanmaken taak", err);
      alert("Aanmaken mislukt.");
    }
  };

  if (!["super_admin", "locatie_admin"].includes(role)) {
    return <p>Je hebt geen rechten om een taak aan te maken.</p>;
  }

  return (
    <div className="container mt-4">
      <h2>Nieuwe Taak</h2>
      <TaskForm onSubmit={handleCreate} />
    </div>
  );
}

export default NewTask;
